export const minimumGridColumns = 1;
export const maximumGridColumns = 12;
